import { render } from "./BuildNotice.vue?vue&type=template&id=3714656d&scoped=true"
import script from "./BuildNotice.vue?vue&type=script&lang=js"
export * from "./BuildNotice.vue?vue&type=script&lang=js"

import "./BuildNotice.vue?vue&type=style&index=0&id=3714656d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3714656d"]])

export default __exports__